import React, { useState, useEffect } from 'react';
import { generateRandomGradient } from 'src/latest/src/utils';
import { getPicture } from 'src/redux/services/commonServices';

interface GetTherapyAddressImageProps {
  id: string;
  isAppointmentLocation: any;
}

const IconPath = '/icons/';

export const TherapyAddressImage: React.FC<GetTherapyAddressImageProps> = ({
  id,
  isAppointmentLocation,
}) => {
  const [image, setImage] = useState<string | undefined>();
  const [imageBackground, setImageBackground] = useState<string>('');

  const getImage = async (id: string) => {
    const imageData = await getPicture(id);

    setImage(imageData);
  };

  useEffect(() => {
    if (!id) {
      setImageBackground(generateRandomGradient());

      return;
    }
  
    const isDefaultOfficeImage = id.includes('defaultofficepic.svg');

    isDefaultOfficeImage ? setImageBackground('') : getImage(id);

  }, [id]);

  return (
    <label
      className={`${
        isAppointmentLocation
          ? 'appointmentLocation-in-person-ofc-image'
          : 'practice-profile__in-person-ofc-image  therapist-profile__in-person-ofc-image'
      }`}
      style={{
        background:
          id && id.includes('defaultofficepic.svg')
            ? imageBackground
            : `url(${image})`,
      }}
    >
      {id && id.includes('defaultofficepic.svg') ? (
        <img
          id='img'
          src={`${IconPath + 'defaultofficepic.svg'}`}
          alt='address'
          className='default-ofc-img'
        />
      ) : null}
    </label>
  );
};
